function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4375 1.75H10.5V4.375H5.25V1.75H1.3125C0.587891 1.75 0 2.33789 0 3.0625V12.6875C0 13.4121 0.587891 14 1.3125 14H14.4375C15.1621 14 15.75 13.4121 15.75 12.6875V3.0625C15.75 2.33789 15.1621 1.75 14.4375 1.75ZM7.875 6.125C8.84023 6.125 9.625 6.90977 9.625 7.875C9.625 8.84023 8.84023 9.625 7.875 9.625C6.90977 9.625 6.125 8.84023 6.125 7.875C6.125 6.90977 6.90977 6.125 7.875 6.125ZM10.4262 12.25H5.32383C5.03945 12.25 4.80977 11.9766 4.89727 11.7086C5.12422 11.0086 5.7832 10.5 6.5625 10.5H6.78672C7.12305 10.6395 7.48945 10.7188 7.875 10.7188C8.26055 10.7188 8.62969 10.6395 8.96328 10.5H9.1875C9.96406 10.5 10.623 11.0059 10.8527 11.7086C10.9402 11.9766 10.7105 12.25 10.4262 12.25ZM9.625 0.875C9.625 0.391016 9.23398 0 8.75 0H7C6.51602 0 6.125 0.391016 6.125 0.875V3.5H9.625V0.875Z"
});

function SvgBage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "#3D4B57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBage);
export default __webpack_public_path__ + "static/media/bage.b0ea55d8.svg";
export { ForwardRef as ReactComponent };